// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"MZ-z","subtitle":"NZ-z","wrapper":"OZ-z","leftArrow":"PZ-z","rightArrow":"QZ-z"};